<template>
  <div>
    <h4 class="mb-1">{{ $t('cancellation.product_policy_title') }}</h4>
    <small class="text-muted d-block mb-3">{{ $t('cancellation.product_policy_hint') }}</small>

    <div class="vx-row">
      <div class="vx-col lg:w-1/2 w-full">
        <b-form-group :label="$t('cancellation.policy')" label-for="product_policy">
          <v-select
            id="product_policy"
            v-model="selectedPolicyId"
            :options="policyOptions"
            :reduce="opt => opt.id"
            label="label"
            :placeholder="$t('cancellation.product_policy_inherit')"
            :clearable="true"
            class="w-full"
            @input="save">
            <div slot="no-options">{{ $t('cancellation.product_policy_none') }}</div>
          </v-select>
        </b-form-group>

        <div v-if="selectedPolicy" class="border rounded p-1 mt-1">
          <div class="flex justify-between mb-50">
            <small class="text-muted">{{ $t('cancellation.version') }}</small>
            <small v-if="selectedPolicy.active_version">
              v{{ selectedPolicy.active_version.version }} · {{ $t('cancellation.version_status_.AC') }}
            </small>
            <small v-else class="text-warning">{{ $t('cancellation.product_policy_no_active') }}</small>
          </div>
          <div class="flex justify-between mb-50">
            <small class="text-muted">{{ $t('cancellation.applied_to') }}</small>
            <small>{{ selectedPolicy.applies_to || '—' }}</small>
          </div>
          <div class="flex justify-between">
            <small class="text-muted">{{ $t('cancellation.establishments') }}</small>
            <small>{{ selectedPolicy.establishment_names || '—' }}</small>
          </div>
        </div>
        <div v-else class="border rounded p-1 mt-1">
          <small class="text-muted">{{ $t('cancellation.product_policy_inherit_hint') }}</small>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { BFormGroup } from 'bootstrap-vue'
import vSelect from 'vue-select'

import ProductCancellationRuleService from '@/services/api/ProductCancellationRuleService'

export default {
  components: {
    BFormGroup,
    vSelect
  },

  props: {
    productId: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    service: null,
    policies: [],
    selectedPolicyId: null,
    loading: false
  }),

  computed: {
    policyOptions() {
      return this.policies.map(policy => ({
        id: policy.id,
        label: policy.name + (policy.active_version ? ` · v${policy.active_version.version}` : '')
      }))
    },
    selectedPolicy() {
      return this.policies.find(policy => policy.id === this.selectedPolicyId) || null
    }
  },

  methods: {
    loadData() {
      this.loading = true
      this.service.forProduct(this.productId).then(
        data => {
          this.policies = data.policies || []
          this.selectedPolicyId = data.rule ? data.rule.policy_id : null
        },
        () => {}
      ).finally(() => { this.loading = false })
    },
    save() {
      if (this.loading) return
      this.$vs.loading()
      this.service.setForProduct(this.productId, this.selectedPolicyId).then(
        () => { this.notifySuccess(this.$vs, this.$t('messages.success')) },
        () => { this.loadData() }
      ).finally(() => { this.$vs.loading.close() })
    }
  },

  beforeMount() {
    this.service = ProductCancellationRuleService.build(this.$vs)
  },

  mounted() {
    this.loadData()
  }
}
</script>
